import { render } from "./Graduates.vue?vue&type=template&id=a595e332&scoped=true"
import script from "./Graduates.vue?vue&type=script&lang=js"
export * from "./Graduates.vue?vue&type=script&lang=js"

import "./Graduates.vue?vue&type=style&index=0&id=a595e332&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a595e332"]])

export default __exports__